const doc = [({"en":({"js":({"activities":({"show":({"surveys_connected_with_activity":"Surveys connected with %{activity_name}"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;